
import React, { useState, useEffect } from "react";
import {
  FaEdit,
  FaTrash,
  FaSave,
  FaPlus,
  FaMoneyBillWave,
  FaPercentage,
  FaCity,
  FaCalendar,
  FaClock,
  FaEye,
  FaTag,
  FaTv,
  FaGlobe,
  FaUser,
  FaCog,
  FaChartLine,
  FaDollarSign,
  FaUsers,
  FaBuilding,
  FaCheckCircle,
  FaTimesCircle,
  FaSpinner,
  FaExclamationTriangle,
  FaWallet,
  FaHistory,
  FaTrashAlt
} from "react-icons/fa";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PriceSet = () => {
  const [adTypes, setAdTypes] = useState([]);
  const [channelTypes, setChannelTypes] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [withdrawalAmount, setWithdrawalAmount] = useState("");
  const [withdrawalSuccess, setWithdrawalSuccess] = useState("");
  const [withdrawalError, setWithdrawalError] = useState("");
  const [gstRate, setGstRate] = useState("");
  const [adCommission, setAdCommission] = useState("");
  const [daysPrice, setDaysPrice] = useState("");
  const [adLengthPrice, setAdLengthPrice] = useState("");
  const [cityPrice, setCityPrice] = useState("");
  const [baseViews, setBaseViews] = useState("");
  const [approvedAdTiming, setApprovedAdTiming] = useState("");
  const [adTimingLoading, setAdTimingLoading] = useState(false);
  const [adTimingSuccess, setAdTimingSuccess] = useState("");
  const [adTimingError, setAdTimingError] = useState("");
  const [reporterPrice, setReporterPrice] = useState("");
  const [reporterPriceLoading, setReporterPriceLoading] = useState(false);
  const [reporterPriceSuccess, setReporterPriceSuccess] = useState("");
  const [reporterPriceError, setReporterPriceError] = useState("");
  const [paidConferenceCommission, setPaidConferenceCommission] = useState("");
  const [paidConferenceCommissionLoading, setPaidConferenceCommissionLoading] = useState(false);
  const [paidConferenceCommissionSuccess, setPaidConferenceCommissionSuccess] = useState("");
  const [paidConferenceCommissionError, setPaidConferenceCommissionError] = useState("");
  const [maxAdLength, setMaxAdLength] = useState("");
  const [minAdLength, setMinAdLength] = useState("");

  // Confirmation dialog state
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [changesSummary, setChangesSummary] = useState({});

  // Reset feature states
  const [showResetConfirmDialog, setShowResetConfirmDialog] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [clearingData, setClearingData] = useState(false);

  // Checkbox states for clearing options
  const [clearWallet, setClearWallet] = useState(false);
  const [clearPaymentHistory, setClearPaymentHistory] = useState(false);
  const [clearWithdrawalRequests, setClearWithdrawalRequests] = useState(false);
  const [clearWithdrawalHistory, setClearWithdrawalHistory] = useState(false);

  // Function to set approved ad timing via API
  const handleSetApprovedAdTiming = async () => {
    setAdTimingLoading(true);
    setAdTimingSuccess("");
    setAdTimingError("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/set/approved/adtiming`,
        { hours: approvedAdTiming },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Approved Ad Timing Response:", response);
      if (response.data && response.data.success) {
        setAdTimingSuccess("Approved ad timing set successfully!");
        toast.success("Approved ad timing set successfully!");
      } else {
        setAdTimingError(response.data?.message || "Failed to set approved ad timing");
        toast.error(response.data?.message || "Failed to set approved ad timing");
      }
    } catch (error) {
      setAdTimingError("Failed to set approved ad timing. Please try again.");
      toast.error("Failed to set approved ad timing. Please try again.");
    } finally {
      setAdTimingLoading(false);
    }
  };

  // Function to set reporter price via API
  const handleSetReporterPrice = async () => {
    setReporterPriceLoading(true);
    setReporterPriceSuccess("");
    setReporterPriceError("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/set/reporter/price`,
        { price: reporterPrice },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Reporter Price Response:", response);
      if (response.data && response.data.success) {
        setReporterPriceSuccess("Reporter price set successfully!");
        toast.success("Reporter price set successfully!");
      } else {
        setReporterPriceError(response.data?.message || "Failed to set reporter price");
        toast.error(response.data?.message || "Failed to set reporter price");
      }
    } catch (error) {
      setReporterPriceError("Failed to set reporter price. Please try again.");
      toast.error("Failed to set reporter price. Please try again.");
    } finally {
      setReporterPriceLoading(false);
    }
  };

  // Function to set paid conference commission via API
  const handleSetPaidConferenceCommission = async () => {
    setPaidConferenceCommissionLoading(true);
    setPaidConferenceCommissionSuccess("");
    setPaidConferenceCommissionError("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/set/paid-conference/commission`,
        { commission: paidConferenceCommission },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Paid Conference Commission Response:", response);
      if (response.data && response.data.success) {
        setPaidConferenceCommissionSuccess("Paid conference commission set successfully!");
        toast.success("Paid conference commission set successfully!");
      } else {
        setPaidConferenceCommissionError(response.data?.message || "Failed to set paid conference commission");
        toast.error(response.data?.message || "Failed to set paid conference commission");
      }
    } catch (error) {
      setPaidConferenceCommissionError("Failed to set paid conference commission. Please try again.");
      toast.error("Failed to set paid conference commission. Please try again.");
    } finally {
      setPaidConferenceCommissionLoading(false);
    }
  };

  const handleQuickDeleteImage = async (index, imageUrl) => {
    if (!window.confirm("Are you sure you want to remove this image?")) return;
    
    const adType = adTypes[index];
    const remaining = (adType.images || []).filter(img => img !== imageUrl);
    
    try {
      const formData = new FormData();
      formData.append("name", adType.name);
      formData.append("price", adType.price);
      formData.append("imageUpdate", "true");
      remaining.forEach(img => formData.append("remainingImages[]", img));

      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/admin/ad-type/edit/${adType.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
        }
      );

      if (response.data && response.data.success) {
        toast.success("Image removed!");
        fetchPricing();
      }
    } catch (error) {
      toast.error("Failed to remove image");
    }
  };
  const [newAdType, setNewAdType] = useState({ name: "", price: "", images: [] });
  const [newChannel, setNewChannel] = useState({ name: "" });
  const [newPlatform, setNewPlatform] = useState("");
  const [savedData, setSavedData] = useState({});
  const [editingAdType, setEditingAdType] = useState(null);
  const [editingPrice, setEditingPrice] = useState("");
  const [editingName, setEditingName] = useState("");
  const [editingNewImages, setEditingNewImages] = useState([]);
  const [remainingImages, setRemainingImages] = useState([]);

  // Function to start editing an ad type
  const handleEditAdType = (index, currentPrice, currentName, currentImages) => {
    setEditingAdType(index);
    setEditingPrice(currentPrice.toString());
    setEditingName(currentName);
    setRemainingImages(currentImages || []);
    setEditingNewImages([]);
  };

  // Function to save the edited ad type price
  const handleSaveAdTypePrice = async (index) => {
    const adType = adTypes[index];
    if (!adType || !adType.id) {
      toast.error("Ad type ID not found");
      return;
    }

    if (!editingPrice || isNaN(editingPrice) || parseFloat(editingPrice) < 0) {
      toast.error("Please enter a valid price");
      return;
    }
    
    if (!editingName || editingName.trim() === "") {
        toast.error("Please enter a name");
        return;
    }

    try {
      const formData = new FormData();
      formData.append("name", editingName.trim());
      formData.append("price", parseFloat(editingPrice));
      formData.append("imageUpdate", "true"); // Flag to signal image list might be empty
      
      // Send the images we want to keep
      remainingImages.forEach(img => {
          formData.append("remainingImages[]", img);
      });
      
      // Send new images if any
      if (editingNewImages && editingNewImages.length > 0) {
          editingNewImages.forEach(file => {
              formData.append("images", file);
          });
      }

      // Diagnostic Log
      const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5005';
      console.log(`📤 Sending PUT (Edit) to: ${apiBase}/admin/ad-type/edit/${adType.id} [LOCAL-DEBUG]`);
      console.log("📦 FormData keys:", Array.from(formData.keys()));

      const response = await axios.put(
        `${apiBase}/admin/ad-type/edit/${adType.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
        }
      );

      if (response.data && response.data.success) {
        toast.success("Ad type updated successfully!");
        setEditingAdType(null);
        setEditingPrice("");
        setEditingName("");
        setEditingNewImages([]);
        setRemainingImages([]);
        // Refresh the pricing data
        await fetchPricing();
      } else {
        toast.error(response.data?.message || "Failed to update ad type");
      }
    } catch (error) {
      console.error("Error updating ad type:", error);
      const errorMsg = error.response?.data?.error || error.response?.data?.message || "Failed to update ad type. Please try again.";
      toast.error(errorMsg);
    }
  };

  // Function to cancel editing
  const handleCancelEdit = () => {
    setEditingAdType(null);
    setEditingPrice("");
    setEditingName("");
    setEditingNewImages([]);
    setRemainingImages([]);
  };

  const fetchPricing = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/get/ad/pricing`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log("Pricing data fetched:", response.data);

      if (response.data.success) {
        const data = response.data.data;
        console.log("📥 Fetched pricing data:", data);
        console.log("📥 Withdrawal amount from API:", data.minimumWithdrawAmountForReporter);

        // ✅ Ensure adTypes have IDs - add IDs if missing
        const adTypesWithIds = (data.adType || []).map((type, index) => ({
          ...type,
          id: type.id || Date.now() + index,
          price: type.price || 0
        }));
        setAdTypes(adTypesWithIds);

        // ✅ Ensure channelTypes have IDs - add IDs if missing
        const channelTypesWithIds = (data.channelType || []).map((type, index) => ({
          ...type,
          id: type.id || Date.now() + index + 10000,
          name: type.name || ''
        }));
        setChannelTypes(channelTypesWithIds);

        setGstRate(data.gstRate ?? "");
        setAdCommission(data.adCommission ?? "");
        setDaysPrice(data.perDayPrice ?? "");
        setAdLengthPrice(data.perSecPrice ?? "");
        setCityPrice(data.perCityPrice ?? "");
        setBaseViews(data.baseView ?? "");
        setPlatforms(data.plateforms || []);
        setWithdrawalAmount(data.minimumWithdrawAmountForReporter ?? "");
        setApprovedAdTiming(data.reporterAcceptTimeInHours ?? "");
        setReporterPrice(data.reporterPrice ?? "");
        setPaidConferenceCommission(data.paidConferenceCommission ?? "");
        setMaxAdLength(data.maxAdLength ?? "");
        setMinAdLength(data.minAdLength ?? "");
        setSavedData(data);
      }
    } catch (error) {
      console.error("Failed to fetch pricing data", error);
    }
  };

  useEffect(() => {
    fetchPricing();
  }, []);

  // Function to generate changes summary
  const generateChangesSummary = () => {
    const changes = {};

    // GST Rate
    if (gstRate && gstRate !== savedData.gstRate) {
      changes['GST Rate'] = { old: savedData.gstRate || 'N/A', new: gstRate };
    }

    // Ad Commission
    if (adCommission && adCommission !== savedData.adCommission) {
      changes['Ad Commission'] = { old: savedData.adCommission || 'N/A', new: adCommission };
    }

    // Price Per City
    if (cityPrice && cityPrice !== savedData.perCityPrice) {
      changes['Price Per City'] = { old: savedData.perCityPrice || 'N/A', new: cityPrice };
    }

    // Price Per Day
    if (daysPrice && daysPrice !== savedData.perDayPrice) {
      changes['Price Per Day'] = { old: savedData.perDayPrice || 'N/A', new: daysPrice };
    }

    // Price Per Second
    if (adLengthPrice && adLengthPrice !== savedData.perSecPrice) {
      changes['Price Per Second'] = { old: savedData.perSecPrice || 'N/A', new: adLengthPrice };
    }

    // Base Views
    if (baseViews && baseViews !== savedData.baseView) {
      changes['Base Views'] = { old: savedData.baseView || 'N/A', new: baseViews };
    }

    // Withdrawal Amount
    if (withdrawalAmount && withdrawalAmount !== savedData.minimumWithdrawAmountForReporter) {
      changes['Withdrawal Amount'] = { old: savedData.minimumWithdrawAmountForReporter || 'N/A', new: withdrawalAmount };
    }

    // Max Ad Length
    if (maxAdLength && maxAdLength !== savedData.maxAdLength) {
      changes['Max Ad Length'] = { old: savedData.maxAdLength || 'N/A', new: maxAdLength };
    }

    // Min Ad Length
    if (minAdLength && minAdLength !== savedData.minAdLength) {
      changes['Min Ad Length'] = { old: savedData.minAdLength || 'N/A', new: minAdLength };
    }

    // Ad Types changes
    const adTypeChanges = adTypes.filter(type => {
      const savedType = savedData.adType?.find(saved => saved.name === type.name);
      return savedType && savedType.price !== type.price;
    });

    if (adTypeChanges.length > 0) {
      changes['Ad Types'] = adTypeChanges.map(type => ({
        name: type.name,
        old: savedData.adType?.find(saved => saved.name === type.name)?.price || 'N/A',
        new: type.price
      }));
    }

    return changes;
  };

  // Function to handle save button click
  const handleSaveClick = () => {
    const changes = generateChangesSummary();

    if (Object.keys(changes).length === 0) {
      toast.info("No changes detected to save.");
      return;
    }

    setChangesSummary(changes);
    setShowConfirmDialog(true);
  };

  const savePricingSettings = async () => {
    try {
      console.log("💾 Saving pricing settings...");
      console.log("💾 Withdrawal amount being sent:", withdrawalAmount);

      // ✅ Ensure adTypes have valid IDs and data
      const validAdTypes = adTypes
        .filter(type => type && type.name && type.name.trim() !== '' && !isNaN(type.price) && parseFloat(type.price) >= 0)
        .map((type, index) => ({
          id: type.id || Date.now() + index, // Generate ID if missing
          name: type.name.trim(),
          price: parseFloat(type.price),
        }));

      // ✅ Ensure channelTypes have valid IDs and data
      const validChannelTypes = channelTypes
        .filter(type => type && type.name && type.name.trim() !== '')
        .map((type, index) => ({
          id: type.id || Date.now() + index + 10000, // Generate ID if missing
          name: type.name.trim(),
        }));

      const pricingData = {
        // adType and channelType are handled by separate API calls, so we don't send them here to avoid overwriting
        gstRate,
        perDayPrice: daysPrice,
        perSecPrice: adLengthPrice,
        baseView: baseViews,
        perCityPrice: cityPrice,
        withdrawAmount: withdrawalAmount,
        adCommission,
        plateforms: platforms.filter(p => p && p.trim() !== '').map(p => p.trim()),
        maxAdLength,
        minAdLength,
        // facebookVideoLink and approvedAdTiming are saved only via their own buttons
      };

      console.log("💾 Complete pricing data being sent:", pricingData);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/priceset`,
        pricingData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.success) {
        toast.success("Pricing settings saved successfully!");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error(response.data?.message || "Failed to save pricing settings");
      }
    } catch (error) {
      console.error("Error saving pricing settings:", error);
      toast.error("Failed to save pricing settings. Please try again.");
    }
  };

  // Function to fetch payments and wallets summary
  const fetchPaymentsAndWalletsSummary = async () => {
    setLoadingSummary(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/payments-wallets/summary`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data && response.data.success) {
        setSummaryData(response.data.data);
        toast.success("Summary fetched successfully!");
      } else {
        toast.error(response.data?.message || "Failed to fetch summary");
      }
    } catch (error) {
      console.error("Error fetching summary:", error);
      toast.error("Failed to fetch summary. Please try again.");
    } finally {
      setLoadingSummary(false);
    }
  };

  // Function to clear all payments and wallets
  const clearAllPaymentsAndWallets = async () => {
    // Validate at least one checkbox is selected
    if (!clearWallet && !clearPaymentHistory && !clearWithdrawalRequests && !clearWithdrawalHistory) {
      toast.error("Please select at least one option to clear");
      return;
    }

    setClearingData(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/clear/all/payments-and-wallets`,
        {
          clearWallet,
          clearPaymentHistory,
          clearWithdrawalRequests,
          clearWithdrawalHistory
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.success) {
        toast.success(response.data.message || "Data cleared successfully!");
        setShowResetConfirmDialog(false);
        // Reset checkboxes
        setClearWallet(false);
        setClearPaymentHistory(false);
        setClearWithdrawalRequests(false);
        setClearWithdrawalHistory(false);
        // Refresh summary after clearing
        setTimeout(() => {
          fetchPaymentsAndWalletsSummary();
        }, 1000);
      } else {
        toast.error(response.data?.message || "Failed to clear data");
      }
    } catch (error) {
      console.error("Error clearing data:", error);
      toast.error(error.response?.data?.message || "Failed to clear data. Please try again.");
    } finally {
      setClearingData(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <ToastContainer />

      {/* Modern Header */}
      <div className="max-w-7xl mx-auto mb-2 md:mb-4 px-2 md:px-0 mt-[-10px] md:mt-0">
        <div className="bg-gradient-to-r from-slate-800 via-slate-900 to-black rounded-xl shadow-lg p-3 md:p-4 text-white border border-slate-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2 md:space-x-3">
              <div className="p-1.5 md:p-2 bg-emerald-500/20 rounded-lg backdrop-blur-sm border border-emerald-500/30">
                <FaCog className="text-lg md:text-xl text-emerald-400" />
              </div>
              <div>
                <h1 className="text-base md:text-xl font-black uppercase tracking-tight">Economic Core</h1>
                <p className="text-slate-400 text-[8px] md:text-sm font-bold uppercase tracking-widest leading-none">Global Pricing Infrastructure</p>
              </div>
            </div>
            <button
              onClick={handleSaveClick}
              className="bg-emerald-600 hover:bg-emerald-500 text-white font-black px-3 md:px-6 py-1.5 md:py-2.5 rounded-lg md:rounded-xl shadow-lg transition-all duration-300 flex items-center gap-1.5 text-[10px] md:text-sm uppercase tracking-wider border-b-2 border-emerald-800 active:translate-y-0.5 active:border-b-0"
            >
              <FaSave className="hidden md:block w-3 h-3 md:w-4 md:h-4" />
              Save Config
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-2 md:px-8 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3 md:gap-4">

          {/* GST & Commission Section */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="bg-slate-900 px-3 py-2 text-white flex items-center justify-between">
              <h3 className="text-[11px] md:text-sm font-black flex items-center gap-2 uppercase tracking-widest">
                <FaPercentage className="w-3 h-3 text-emerald-400" />
                Fiscal Protocol
              </h3>
            </div>
            <div className="p-3 md:p-4 space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-slate-50/50 p-2 rounded-lg border border-slate-100">
                  <label className="block text-[9px] font-black text-slate-400 mb-1 uppercase tracking-widest">
                    GST Rate (%)
                  </label>
                  <input
                    type="number"
                    value={gstRate}
                    onChange={(e) => setGstRate(e.target.value)}
                    placeholder="Rate"
                    className="w-full bg-white border border-slate-200 p-2 text-xs md:text-sm rounded-lg focus:ring-2 focus:ring-slate-900 outline-none font-bold"
                  />
                  <div className="text-[8px] text-slate-400 mt-1 flex items-center gap-1 font-bold uppercase tracking-tighter">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                    Current: {savedData.gstRate ?? "0"}%
                  </div>
                </div>
                <div className="bg-slate-50/50 p-2 rounded-lg border border-slate-100">
                  <label className="block text-[9px] font-black text-slate-400 mb-1 uppercase tracking-widest">
                    Admin Comm (%)
                  </label>
                  <input
                    type="number"
                    value={adCommission}
                    onChange={(e) => setAdCommission(e.target.value)}
                    placeholder="Comm"
                    className="w-full bg-white border border-slate-200 p-2 text-xs md:text-sm rounded-lg focus:ring-2 focus:ring-slate-900 outline-none font-bold"
                  />
                  <div className="text-[8px] text-slate-400 mt-1 flex items-center gap-1 font-bold uppercase tracking-tighter">
                    <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                    Current: {savedData.adCommission ?? "0"}%
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Pricing Section */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="bg-slate-900 px-3 py-2 text-white">
              <h3 className="text-[11px] md:text-sm font-black flex items-center gap-2 uppercase tracking-widest">
                <FaMoneyBillWave className="w-3 h-3 text-yellow-400" />
                Unit Valuations
              </h3>
            </div>
            <div className="p-3 md:p-4 space-y-2 md:space-y-3">
              <div className="grid grid-cols-2 gap-2 md:gap-3">
                <div className="bg-slate-50/50 p-2 rounded-lg border border-slate-100">
                  <label className="block text-[9px] font-black text-slate-400 mb-0.5 uppercase tracking-widest">
                    Price / City
                  </label>
                  <div className="relative">
                    <span className="absolute left-2 top-1.5 text-slate-400 font-bold text-xs">₹</span>
                    <input
                      type="number"
                      value={cityPrice}
                      onChange={(e) => setCityPrice(e.target.value)}
                      placeholder="Price"
                      className="w-full bg-white border border-slate-200 pl-5 pr-2 py-1.5 md:py-2 text-[11px] md:text-sm rounded-lg font-bold outline-none"
                    />
                  </div>
                  <div className="text-[8px] text-slate-400 mt-1 font-bold uppercase tracking-tighter">
                    Saved: ₹{savedData.perCityPrice ?? "0"}
                  </div>
                </div>
                <div className="bg-slate-50/50 p-2 rounded-lg border border-slate-100">
                  <label className="block text-[9px] font-black text-slate-400 mb-0.5 uppercase tracking-widest">
                    Price / Day
                  </label>
                  <div className="relative">
                    <span className="absolute left-2 top-1.5 text-slate-400 font-bold text-xs">₹</span>
                    <input
                      type="number"
                      value={daysPrice}
                      onChange={(e) => setDaysPrice(e.target.value)}
                      placeholder="Price"
                      className="w-full bg-white border border-slate-200 pl-5 pr-2 py-1.5 md:py-2 text-[11px] md:text-sm rounded-lg font-bold outline-none"
                    />
                  </div>
                  <div className="text-[8px] text-slate-400 mt-1 font-bold uppercase tracking-tighter">
                    Saved: ₹{savedData.perDayPrice ?? "0"}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 md:gap-3">
                <div className="bg-slate-50/50 p-2 rounded-lg border border-slate-100">
                  <label className="block text-[9px] font-black text-slate-400 mb-0.5 uppercase tracking-widest">
                    Price / Sec
                  </label>
                  <div className="relative">
                    <span className="absolute left-2 top-1.5 text-slate-400 font-bold text-xs">₹</span>
                    <input
                      type="number"
                      value={adLengthPrice}
                      onChange={(e) => setAdLengthPrice(e.target.value)}
                      placeholder="Price"
                      className="w-full bg-white border border-slate-200 pl-5 pr-2 py-1.5 md:py-2 text-[11px] md:text-sm rounded-lg font-bold outline-none"
                    />
                  </div>
                  <div className="text-[8px] text-slate-400 mt-1 font-bold uppercase tracking-tighter">
                    Saved: ₹{savedData.perSecPrice ?? "0"}
                  </div>
                </div>
                <div className="bg-slate-50/50 p-2 rounded-lg border border-slate-100">
                  <label className="block text-[9px] font-black text-slate-400 mb-0.5 uppercase tracking-widest">
                    Base Views
                  </label>
                  <input
                    type="number"
                    value={baseViews}
                    onChange={(e) => setBaseViews(e.target.value)}
                    placeholder="Views"
                    className="w-full bg-white border border-slate-200 p-2 text-[11px] md:text-sm rounded-lg font-bold outline-none"
                  />
                  <div className="text-[8px] text-slate-400 mt-1 font-bold uppercase tracking-tighter">
                    Saved: {savedData.baseView ?? "0"}
                  </div>
                </div>
              </div>

              {/* Ad Length Settings */}
              <div className="grid grid-cols-2 gap-2 md:gap-3">
                <div className="bg-slate-50/50 p-2 rounded-lg border border-slate-100">
                  <label className="block text-[9px] font-black text-slate-400 mb-0.5 uppercase tracking-widest">
                    Max Len (s)
                  </label>
                  <input
                    type="number"
                    value={maxAdLength}
                    onChange={(e) => setMaxAdLength(e.target.value)}
                    placeholder="Max"
                    className="w-full bg-white border border-slate-200 p-2 text-[11px] md:text-sm rounded-lg font-bold outline-none"
                  />
                  <div className="text-[8px] text-slate-400 mt-1 font-bold uppercase tracking-tighter">
                    Limit: {savedData.maxAdLength ?? "600"}s
                  </div>
                </div>
                <div className="bg-slate-50/50 p-2 rounded-lg border border-slate-100">
                  <label className="block text-[9px] font-black text-slate-400 mb-0.5 uppercase tracking-widest">
                    Min Len (s)
                  </label>
                  <input
                    type="number"
                    value={minAdLength}
                    onChange={(e) => setMinAdLength(e.target.value)}
                    placeholder="Min"
                    className="w-full bg-white border border-slate-200 p-2 text-[11px] md:text-sm rounded-lg font-bold outline-none"
                  />
                  <div className="text-[8px] text-slate-400 mt-1 font-bold uppercase tracking-tighter">
                    Limit: {savedData.minAdLength ?? "5"}s
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Ad Types Section */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="bg-slate-900 px-3 py-2 text-white">
              <h3 className="text-[11px] md:text-sm font-black flex items-center gap-2 uppercase tracking-widest">
                <FaTag className="w-3 h-3 text-purple-400" />
                Ad Variance
              </h3>
            </div>
            <div className="p-3 md:p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-3">
                {adTypes.map((type, index) => (
                  <div key={index} className="flex justify-between items-center bg-slate-50 p-2 rounded-lg border border-slate-100 group">
                    <div className="flex items-center gap-2 flex-1 min-w-0">
                      <div className="relative">
                        <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center shrink-0 overflow-hidden border border-purple-200">
                          {type.images && type.images.length > 0 ? (
                            <img 
                              src={`${process.env.REACT_APP_API_BASE_URL}${type.images[0]}`} 
                              alt={type.name} 
                              className="w-full h-full object-cover"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://via.placeholder.com/150?text=No+Img";
                              }}
                            />
                          ) : (
                            <FaTag className="w-3 h-3 text-purple-600" />
                          )}
                        </div>
                        {type.images && type.images.length > 1 && (
                          <div className="absolute -bottom-1 -right-1 bg-slate-900 text-[8px] text-white w-4 h-4 rounded-full flex items-center justify-center font-black border border-white">
                            +{type.images.length - 1}
                          </div>
                        )}
                      </div>
                      <div className="min-w-0 flex-1">
                        {editingAdType === index ? (
                          <div className="space-y-2 p-1 bg-white rounded border border-purple-100 shadow-sm">
                            <input
                              type="text"
                              value={editingName}
                              onChange={(e) => setEditingName(e.target.value)}
                              className="w-full px-2 py-1 text-xs border border-slate-200 rounded focus:ring-1 focus:ring-purple-500 outline-none font-bold"
                              placeholder="Name"
                            />
                            <div className="flex items-center gap-2">
                                <div className="flex-1 flex items-center gap-1 bg-slate-50 px-2 py-1 rounded">
                                    <span className="text-slate-400 font-bold text-[10px]">₹</span>
                                    <input
                                      type="number"
                                      value={editingPrice}
                                      onChange={(e) => setEditingPrice(e.target.value)}
                                      className="w-full bg-transparent text-xs outline-none font-bold"
                                      placeholder="Price"
                                      min="0"
                                    />
                                </div>
                                <div className="flex gap-1">
                                    <button
                                      onClick={() => handleSaveAdTypePrice(index)}
                                      className="p-1.5 bg-emerald-500 text-white rounded hover:bg-emerald-600 transition-colors"
                                      title="Save"
                                    >
                                      <FaSave className="w-3 h-3" />
                                    </button>
                                    <button
                                      onClick={handleCancelEdit}
                                      className="p-1.5 bg-slate-500 text-white rounded hover:bg-slate-600 transition-colors"
                                      title="Cancel"
                                    >
                                      <FaTimesCircle className="w-3 h-3" />
                                    </button>
                                </div>
                            </div>
                            
                            <div className="space-y-1 mt-2">
                                <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest">Manage Images</label>
                                <div className="flex flex-wrap gap-1">
                                    {remainingImages.map((img, i) => (
                                        <div key={i} className="relative w-8 h-8 rounded border border-slate-200 overflow-hidden group">
                                            <img 
                                                src={`${process.env.REACT_APP_API_BASE_URL}${img}`} 
                                                className="w-full h-full object-cover" 
                                                alt="existing" 
                                            />
                                            <button 
                                                onClick={() => setRemainingImages(remainingImages.filter((_, idx) => idx !== i))}
                                                className="absolute -top-0.5 -right-0.5 bg-red-500 text-white rounded-full w-3.5 h-3.5 flex items-center justify-center hover:bg-red-600 border border-white"
                                            >
                                                <FaTrash className="w-2 h-2" />
                                            </button>
                                        </div>
                                    ))}
                                    {editingNewImages.map((file, i) => (
                                        <div key={i} className="relative w-8 h-8 rounded border border-emerald-200 overflow-hidden bg-emerald-50">
                                            <img 
                                                src={URL.createObjectURL(file)} 
                                                className="w-full h-full object-cover" 
                                                alt="new" 
                                            />
                                            <button 
                                                onClick={() => setEditingNewImages(editingNewImages.filter((_, idx) => idx !== i))}
                                                className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-3 h-3 flex items-center justify-center"
                                            >
                                                <FaTrash className="w-1.5 h-1.5" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                                <input
                                    type="file"
                                    multiple
                                    accept="image/*"
                                    onChange={(e) => setEditingNewImages([...editingNewImages, ...Array.from(e.target.files)])}
                                    className="block w-full text-[9px] text-slate-400 file:mr-2 file:py-1 file:px-2 file:rounded file:border-0 file:text-[9px] file:font-black file:bg-slate-100 file:text-slate-600 hover:file:bg-slate-200"
                                />
                            </div>
                          </div>
                        ) : (
                          <>
                            <span className="font-black text-[10px] md:text-xs text-slate-800 uppercase tracking-tight block truncate">{type.name}</span>
                            <div className="flex items-center gap-1.5 mt-0.5">
                                <span className="text-emerald-600 font-black text-[10px] md:text-xs">₹{type.price}</span>
                                <button
                                  onClick={() => handleEditAdType(index, type.price, type.name, type.images)}
                                  className="text-slate-400 hover:text-blue-600 transition-colors"
                                >
                                  <FaEdit className="w-2.5 h-2.5" />
                                </button>
                            </div>

                            {/* Image gallery */}
                            {type.images && type.images.length > 0 && (
                              <div className="flex flex-wrap gap-1 mt-2">
                                 {type.images.map((img, idx) => (
                                   <div key={idx} className="relative w-8 h-8 rounded border border-slate-200 overflow-hidden bg-white group/img">
                                     <img 
                                       src={`${process.env.REACT_APP_API_BASE_URL}${img}`} 
                                       alt={`${type.name} ${idx}`} 
                                       className="w-full h-full object-cover cursor-pointer hover:scale-110 transition-transform"
                                       onClick={() => window.open(`${process.env.REACT_APP_API_BASE_URL}${img}`, '_blank')}
                                       onError={(e) => {
                                         e.target.onerror = null;
                                         e.target.src = "https://via.placeholder.com/150?text=Error";
                                       }}
                                     />
                                     <button 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleQuickDeleteImage(index, img);
                                        }}
                                        className="absolute top-0 right-0 bg-red-500/80 text-white p-0.5 rounded-bl opacity-0 group-hover/img:opacity-100 transition-opacity"
                                     >
                                        <FaTrash className="w-2 h-2" />
                                     </button>
                                   </div>
                                 ))}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <button
                      onClick={async () => {
                        const adType = adTypes[index];
                        if (!adType || !adType.id) {
                          toast.error("Ad type ID not found");
                          return;
                        }

                        if (!window.confirm(`Are you sure you want to delete "${adType.name}"?`)) {
                          return;
                        }

                        try {
                          const response = await axios.delete(
                            `${process.env.REACT_APP_API_BASE_URL}/admin/ad-type/delete/${adType.id}`,
                            {
                              headers: {
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                              },
                            }
                          );

                          if (response.data && response.data.success) {
                            toast.success("Ad type deleted successfully!");
                            // Refresh the pricing data
                            await fetchPricing();
                          } else {
                            toast.error(response.data?.message || "Failed to delete ad type");
                          }
                        } catch (error) {
                          console.error("Error deleting ad type:", error);
                          toast.error(error.response?.data?.message || "Failed to delete ad type. Please try again.");
                        }
                      }}
                      className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                      title="Delete"
                    >
                      <FaTrash className="w-3 h-3" />
                    </button>
                  </div>
                ))}
              </div>
              <div className="space-y-2">
                <div className="grid grid-cols-2 gap-2">
                  <input
                    type="text"
                    placeholder="Name"
                    value={newAdType.name}
                    onChange={(e) => setNewAdType({ ...newAdType, name: e.target.value })}
                    className="border border-gray-300 p-2 text-sm rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
                  />
                  <input
                    type="number"
                    placeholder="Price (₹)"
                    value={newAdType.price}
                    onChange={(e) => setNewAdType({ ...newAdType, price: e.target.value })}
                    className="border border-gray-300 p-2 text-sm rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
                  />
                </div>
                
                {/* Image Upload Input */}
                <div className="flex flex-col gap-2">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest px-1">Upload Images</label>
                  <input
                    key={newAdType.images.length === 0 ? 'reset' : 'active'}
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      setNewAdType({ ...newAdType, images: files });
                    }}
                    className="block w-full text-[10px] text-slate-500 file:mr-4 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-[10px] file:font-black file:bg-purple-50 file:text-purple-700 hover:file:bg-purple-100 transition-all border border-slate-200 rounded-lg p-1 bg-white"
                  />
                  {newAdType.images && newAdType.images.length > 0 && (
                    <div className="flex flex-wrap gap-1 p-1 bg-slate-50 rounded-lg border border-dashed border-slate-200">
                      {newAdType.images.map((file, idx) => (
                        <div key={idx} className="relative w-8 h-8 rounded border border-slate-200 overflow-hidden bg-white group">
                          <img 
                            src={URL.createObjectURL(file)} 
                            alt="preview" 
                            className="w-full h-full object-cover"
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <button
                  onClick={async () => {
                    if (!newAdType.name || !newAdType.price) {
                      toast.error("Please enter both name and price");
                      return;
                    }

                    try {
                      // Prepare FormData
                      const formData = new FormData();
                      formData.append("name", newAdType.name);
                      formData.append("price", parseFloat(newAdType.price));
                      
                      // Append multiple images
                      if (newAdType.images && newAdType.images.length > 0) {
                        newAdType.images.forEach((file) => {
                          formData.append("images", file);
                        });
                      }

                      // Diagnostic Log
                      const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5005';
                      console.log(`📤 Sending POST to: ${apiBase}/admin/ad-type/add [LOCAL-DEBUG]`);
                      console.log("📦 FormData keys:", Array.from(formData.keys()));

                      const response = await axios.post(
                        `${apiBase}/admin/ad-type/add`,
                        formData,
                        {
                          headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`
                          },
                        }
                      );

                      if (response.data && response.data.success) {
                        toast.success("Ad type added successfully!");
                        setNewAdType({ name: '', price: '', images: [] });
                        // Clear the file input if possible (React usually needs a ref for this or a key change)
                        // Trigger re-render of pricing
                        await fetchPricing();
                      } else {
                        toast.error(response.data?.message || "Failed to add ad type");
                      }
                    } catch (error) {
                      console.error("Error adding ad type:", error);
                      const errorMsg = error.response?.data?.error || error.response?.data?.message || "Failed to add ad type. Please try again.";
                      toast.error(errorMsg);
                    }
                  }}
                  className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white px-3 py-2 rounded-lg font-medium text-sm transition-all duration-200 shadow-sm hover:shadow-md flex items-center justify-center gap-2"
                >
                  <FaPlus className="w-3 h-3" />
                  Add
                </button>
              </div>
            </div>
          </div>

          {/* Channel Types Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="bg-gradient-to-r from-orange-500 to-red-500 p-3 text-white">
              <h3 className="text-base font-semibold flex items-center gap-2">
                <FaTv className="w-4 h-4" />
                Channel Types
              </h3>
            </div>
            <div className="p-4">
              <div className="space-y-2 mb-3">
                {channelTypes.map((type, index) => (
                  <div key={index} className="flex justify-between items-center bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
                    <div className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center">
                        <FaTv className="w-3 h-3 text-orange-600" />
                      </div>
                      <span className="font-medium text-sm text-gray-900">{type.name}</span>
                    </div>
                    <button
                      onClick={async () => {
                        const channelType = channelTypes[index];
                        if (!channelType || !channelType.id) {
                          toast.error("Channel type ID not found");
                          return;
                        }

                        if (!window.confirm(`Are you sure you want to delete "${channelType.name}"?`)) {
                          return;
                        }

                        try {
                          const response = await axios.delete(
                            `${process.env.REACT_APP_API_BASE_URL}/admin/channel-type/delete/${channelType.id}`,
                            {
                              headers: {
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                              },
                            }
                          );

                          if (response.data && response.data.success) {
                            toast.success("Channel type deleted successfully!");
                            // Refresh the pricing data
                            await fetchPricing();
                          } else {
                            toast.error(response.data?.message || "Failed to delete channel type");
                          }
                        } catch (error) {
                          console.error("Error deleting channel type:", error);
                          toast.error(error.response?.data?.message || "Failed to delete channel type. Please try again.");
                        }
                      }}
                      className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                      title="Delete"
                    >
                      <FaTrash className="w-3 h-3" />
                    </button>
                  </div>
                ))}
              </div>
              <div className="space-y-2">
                <input
                  type="text"
                  placeholder="Channel Type Name"
                  value={newChannel.name}
                  onChange={(e) => setNewChannel({ name: e.target.value })}
                  className="w-full border border-gray-300 p-2 text-sm rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200"
                />
                <button
                  onClick={async () => {
                    if (!newChannel.name || newChannel.name.trim() === '') {
                      toast.error("Please enter channel type name");
                      return;
                    }

                    try {
                      const response = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/admin/channel-type/add`,
                        {
                          name: newChannel.name.trim()
                        },
                        {
                          headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                            "Content-Type": "application/json",
                          },
                        }
                      );

                      if (response.data && response.data.success) {
                        toast.success("Channel type added successfully!");
                        setNewChannel({ name: '' });
                        // Refresh the pricing data
                        await fetchPricing();
                      } else {
                        toast.error(response.data?.message || "Failed to add channel type");
                      }
                    } catch (error) {
                      console.error("Error adding channel type:", error);
                      toast.error(error.response?.data?.message || "Failed to add channel type. Please try again.");
                    }
                  }}
                  className="w-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white px-3 py-2 rounded-lg font-medium text-sm transition-all duration-200 shadow-sm hover:shadow-md flex items-center justify-center gap-2"
                >
                  <FaPlus className="w-3 h-3" />
                  Add
                </button>
              </div>
            </div>
          </div>

          {/* Platforms Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="bg-gradient-to-r from-cyan-500 to-blue-500 p-3 text-white">
              <h3 className="text-base font-semibold flex items-center gap-2">
                <FaGlobe className="w-4 h-4" />
                Platforms
              </h3>
            </div>
            <div className="p-4">
              <div className="space-y-2 mb-3">
                {platforms.map((platform, index) => (
                  <div key={index} className="flex justify-between items-center bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
                    <div className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-cyan-100 rounded-full flex items-center justify-center">
                        <FaGlobe className="w-3 h-3 text-cyan-600" />
                      </div>
                      <span className="font-medium text-sm text-gray-900">{platform}</span>
                    </div>
                    <button
                      onClick={async () => {
                        const platformName = platforms[index];
                        if (!window.confirm(`Are you sure you want to delete "${platformName}"?`)) {
                          return;
                        }

                        try {
                          const response = await axios.delete(
                            `${process.env.REACT_APP_API_BASE_URL}/admin/platform/delete/${encodeURIComponent(platformName)}`,
                            {
                              headers: {
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                              },
                            }
                          );

                          if (response.data && response.data.success) {
                            toast.success("Platform deleted successfully!");
                            await fetchPricing();
                          } else {
                            toast.error(response.data?.message || "Failed to delete platform");
                          }
                        } catch (error) {
                          console.error("Error deleting platform:", error);
                          toast.error(error.response?.data?.message || "Failed to delete platform");
                        }
                      }}
                      className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      <FaTrash className="w-3 h-3" />
                    </button>
                  </div>
                ))}
              </div>
              <div className="space-y-2">
                <input
                  type="text"
                  placeholder="Platform Name"
                  value={newPlatform}
                  onChange={(e) => setNewPlatform(e.target.value)}
                  className="w-full border border-gray-300 p-2 text-sm rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-200"
                />
                <button
                  onClick={async () => {
                    if (!newPlatform || newPlatform.trim() === '') {
                      toast.error("Please enter a platform name");
                      return;
                    }

                    try {
                      const response = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/admin/platform/add`,
                        { name: newPlatform.trim() },
                        {
                          headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                            "Content-Type": "application/json",
                          },
                        }
                      );

                      if (response.data && response.data.success) {
                        toast.success("Platform added successfully!");
                        setNewPlatform('');
                        await fetchPricing(); // Refresh list from server
                      } else {
                        toast.error(response.data?.message || "Failed to add platform");
                      }
                    } catch (error) {
                      console.error("Error adding platform:", error);
                      toast.error(error.response?.data?.message || "Failed to add platform");
                    }
                  }}
                  className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white px-3 py-2 rounded-lg font-medium text-sm transition-all duration-200 shadow-sm hover:shadow-md flex items-center justify-center gap-2"
                >
                  <FaPlus className="w-3 h-3" />
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Final Row - Compact Controls */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3 md:mt-4">
          {/* Withdrawal Settings */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="bg-slate-900 px-3 py-2 text-white">
              <h3 className="text-[11px] md:text-sm font-black flex items-center gap-2 uppercase tracking-widest">
                <FaDollarSign className="w-3 h-3 text-yellow-400" />
                Withdrawal
              </h3>
            </div>
            <div className="p-3">
              <label className="block text-[9px] font-black text-slate-400 mb-1 uppercase tracking-widest">Min Amount</label>
              <div className="flex gap-2">
                <input
                  type="number"
                  value={withdrawalAmount}
                  onChange={(e) => setWithdrawalAmount(e.target.value)}
                  className="flex-1 bg-white border border-slate-200 p-2 text-xs md:text-sm rounded-lg font-bold outline-none"
                  placeholder="Min"
                />
              </div>
              <div className="text-[8px] text-slate-400 mt-1 font-bold uppercase tracking-tighter">
                Saved: {savedData.minimumWithdrawAmountForReporter ?? "0"}
              </div>
            </div>
          </div>

          {/* Ad Timing */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="bg-slate-900 px-3 py-2 text-white">
              <h3 className="text-[11px] md:text-sm font-black flex items-center gap-2 uppercase tracking-widest">
                <FaClock className="w-3 h-3 text-cyan-400" />
                Timing Policy
              </h3>
            </div>
            <div className="p-3">
              <label className="block text-[9px] font-black text-slate-400 mb-1 uppercase tracking-widest">Accept Time (H)</label>
              <div className="flex gap-2">
                <input
                  type="number"
                  value={approvedAdTiming}
                  onChange={(e) => setApprovedAdTiming(e.target.value)}
                  className="flex-1 bg-white border border-slate-200 p-2 text-xs md:text-sm rounded-lg font-bold outline-none"
                  placeholder="Hours"
                />
                <button
                  onClick={handleSetApprovedAdTiming}
                  disabled={adTimingLoading || !approvedAdTiming}
                  className="bg-slate-800 text-white px-3 py-1.5 rounded-lg font-black text-[10px] uppercase transition-all active:scale-95 disabled:opacity-50"
                >
                  {adTimingLoading ? ".." : "Set"}
                </button>
              </div>
              <div className="text-[8px] text-slate-400 mt-1 font-bold uppercase tracking-tighter">
                Current: {savedData.reporterAcceptTimeInHours ?? "0"}h
              </div>
            </div>
          </div>

          {/* Reporter Base Price */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="bg-slate-900 px-3 py-2 text-white">
              <h3 className="text-[11px] md:text-sm font-black flex items-center gap-2 uppercase tracking-widest">
                <FaUsers className="w-3 h-3 text-emerald-400" />
                Reporter Base
              </h3>
            </div>
            <div className="p-3">
              <label className="block text-[9px] font-black text-slate-400 mb-1 uppercase tracking-widest">Base Rate (₹)</label>
              <div className="flex gap-2">
                <input
                  type="number"
                  value={reporterPrice}
                  onChange={(e) => setReporterPrice(e.target.value)}
                  className="flex-1 bg-white border border-slate-200 p-2 text-xs md:text-sm rounded-lg font-bold outline-none"
                  placeholder="Price"
                />
                <button
                  onClick={handleSetReporterPrice}
                  disabled={reporterPriceLoading || !reporterPrice}
                  className="bg-slate-800 text-white px-3 py-1.5 rounded-lg font-black text-[10px] uppercase transition-all active:scale-95 disabled:opacity-50"
                >
                  {reporterPriceLoading ? ".." : "Set"}
                </button>
              </div>
              <div className="text-[8px] text-slate-400 mt-1 font-bold uppercase tracking-tighter">
                Saved: ₹{savedData.reporterPrice ?? "0"}
              </div>
            </div>
          </div>
        </div>

        {/* Reset Feature Section - Danger Zone */}
        <div className="mt-4 max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-sm border-2 border-red-200 overflow-hidden">
            <div className="bg-gradient-to-r from-red-500 to-red-600 p-3 text-white">
              <h3 className="text-base font-semibold flex items-center gap-2">
                <FaExclamationTriangle className="w-4 h-4" />
                Danger Zone - Reset Feature
              </h3>
              <p className="text-red-100 text-[10px] mt-0.5">⚠️ Clear payment history, wallets, withdrawal requests, and withdrawal history</p>
            </div>
            <div className="p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                {/* Summary Button */}
                <button
                  onClick={fetchPaymentsAndWalletsSummary}
                  disabled={loadingSummary}
                  className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold px-4 py-2 text-sm rounded-lg shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loadingSummary ? (
                    <>
                      <FaSpinner className="w-4 h-4 animate-spin" />
                      Loading...
                    </>
                  ) : (
                    <>
                      <FaEye className="w-4 h-4" />
                      View Summary
                    </>
                  )}
                </button>

                {/* Clear All Button */}
                <button
                  onClick={() => setShowResetConfirmDialog(true)}
                  disabled={clearingData}
                  className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-semibold px-4 py-2 text-sm rounded-lg shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {clearingData ? (
                    <>
                      <FaSpinner className="w-4 h-4 animate-spin" />
                      Clearing...
                    </>
                  ) : (
                    <>
                      <FaTrashAlt className="w-4 h-4" />
                      Clear Selected Data
                    </>
                  )}
                </button>
              </div>

              {/* Checkboxes Section */}
              <div className="bg-gray-50 rounded-lg p-3 border border-gray-200 mb-4">
                <h4 className="font-semibold text-gray-800 text-sm mb-3 flex items-center gap-2">
                  <FaCog className="w-3 h-3" />
                  Select what to clear:
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {/* Wallet Checkbox */}
                  <label className="flex items-center gap-2 p-2 bg-white rounded-md border border-gray-200 hover:border-blue-300 cursor-pointer transition-colors">
                    <input
                      type="checkbox"
                      checked={clearWallet}
                      onChange={(e) => setClearWallet(e.target.checked)}
                      className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                    />
                    <div className="flex items-center gap-2">
                      <FaWallet className="w-3 h-3 text-green-600" />
                      <span className="font-medium text-xs text-gray-700">Clear Wallet</span>
                    </div>
                  </label>

                  {/* Payment History Checkbox */}
                  <label className="flex items-center gap-2 p-2 bg-white rounded-md border border-gray-200 hover:border-blue-300 cursor-pointer transition-colors">
                    <input
                      type="checkbox"
                      checked={clearPaymentHistory}
                      onChange={(e) => setClearPaymentHistory(e.target.checked)}
                      className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                    />
                    <div className="flex items-center gap-2">
                      <FaHistory className="w-3 h-3 text-blue-600" />
                      <span className="font-medium text-xs text-gray-700">Clear Payment History</span>
                    </div>
                  </label>

                  {/* Withdrawal Requests Checkbox */}
                  <label className="flex items-center gap-2 p-2 bg-white rounded-md border border-gray-200 hover:border-blue-300 cursor-pointer transition-colors">
                    <input
                      type="checkbox"
                      checked={clearWithdrawalRequests}
                      onChange={(e) => setClearWithdrawalRequests(e.target.checked)}
                      className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                    />
                    <div className="flex items-center gap-2">
                      <FaMoneyBillWave className="w-3 h-3 text-orange-600" />
                      <span className="font-medium text-xs text-gray-700">Clear Withdrawal Requests</span>
                    </div>
                  </label>

                  {/* Withdrawal History Checkbox */}
                  <label className="flex items-center gap-2 p-2 bg-white rounded-md border border-gray-200 hover:border-blue-300 cursor-pointer transition-colors">
                    <input
                      type="checkbox"
                      checked={clearWithdrawalHistory}
                      onChange={(e) => setClearWithdrawalHistory(e.target.checked)}
                      className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                    />
                    <div className="flex items-center gap-2">
                      <FaHistory className="w-3 h-3 text-purple-600" />
                      <span className="font-medium text-xs text-gray-700">Clear Withdrawal History</span>
                    </div>
                  </label>
                </div>
              </div>

              {/* Summary Display */}
              {summaryData && (
                <div className="mt-4 bg-gray-50 rounded-lg p-3 border border-gray-200">
                  <h4 className="font-semibold text-gray-800 text-xs mb-2 flex items-center gap-2">
                    <FaChartLine className="w-3 h-3" />
                    Current Status
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                    <div className="bg-blue-50 rounded p-2 border border-blue-200">
                      <p className="text-[10px] text-blue-600 font-medium">Payment History</p>
                      <p className="text-sm font-bold text-blue-800">{summaryData.paymentHistory?.totalRecords || 0} records</p>
                    </div>
                    <div className="bg-green-50 rounded p-2 border border-green-200">
                      <p className="text-[10px] text-green-600 font-medium">Total Wallets</p>
                      <p className="text-sm font-bold text-green-800">{summaryData.wallets?.totalWallets || 0} wallets</p>
                    </div>
                    <div className="bg-purple-50 rounded p-2 border border-purple-200">
                      <p className="text-[10px] text-purple-600 font-medium">Wallets with Balance</p>
                      <p className="text-sm font-bold text-purple-800">{summaryData.wallets?.walletsWithBalance || 0} wallets</p>
                    </div>
                    <div className="bg-yellow-50 rounded p-2 border border-yellow-200">
                      <p className="text-[10px] text-yellow-600 font-medium">Total Wallet Balance</p>
                      <p className="text-sm font-bold text-yellow-800">₹{summaryData.wallets?.totalWalletBalance?.toFixed(2) || "0.00"}</p>
                    </div>
                    <div className="bg-orange-50 rounded p-2 border border-orange-200">
                      <p className="text-[10px] text-orange-600 font-medium">Pending Requests</p>
                      <p className="text-sm font-bold text-orange-800">{summaryData.withdrawalRequests?.pendingRequests || 0} requests</p>
                      <p className="text-[10px] text-orange-600">₹{summaryData.withdrawalRequests?.totalPendingAmount?.toFixed(2) || "0.00"}</p>
                    </div>
                    <div className="bg-pink-50 rounded p-2 border border-pink-200">
                      <p className="text-[10px] text-pink-600 font-medium">Withdrawal History</p>
                      <p className="text-sm font-bold text-pink-800">{summaryData.withdrawalHistory?.totalRecords || 0} records</p>
                      <p className="text-[10px] text-pink-600">₹{summaryData.withdrawalHistory?.totalWithdrawnAmount?.toFixed(2) || "0.00"}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>

      {/* Reset Confirmation Dialog */}
      {showResetConfirmDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full">
            {/* Header */}
            <div className="bg-gradient-to-r from-red-500 to-red-600 p-3 text-white rounded-t-xl">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                  <FaExclamationTriangle className="w-4 h-4" />
                </div>
                <div>
                  <h3 className="text-base font-semibold">⚠️ DANGER ZONE</h3>
                  <p className="text-red-100 text-xs">This action cannot be undone!</p>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-4">
              <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-3">
                <p className="text-red-800 font-semibold mb-2 text-sm">⚠️ Warning: This will permanently:</p>
                <ul className="text-xs text-red-700 space-y-1 list-disc list-inside">
                  {clearWallet && <li>Reset ALL wallet balances to ₹0 and clear ALL transactions</li>}
                  {clearPaymentHistory && <li>Delete ALL payment history records</li>}
                  {clearWithdrawalRequests && <li>Delete ALL pending withdrawal requests</li>}
                  {clearWithdrawalHistory && <li>Delete ALL approved withdrawal history records</li>}
                  {!clearWallet && !clearPaymentHistory && !clearWithdrawalRequests && !clearWithdrawalHistory && (
                    <li className="text-red-500 font-semibold">⚠️ No option selected! Please select at least one option.</li>
                  )}
                </ul>
              </div>

              {summaryData && (
                <div className="bg-gray-50 rounded-lg p-2 mb-3">
                  <p className="text-xs font-semibold text-gray-700 mb-1">Current Data (to be cleared):</p>
                  <div className="text-[10px] text-gray-600 space-y-0.5">
                    {clearPaymentHistory && <p>• Payment Records: {summaryData.paymentHistory?.totalRecords || 0}</p>}
                    {clearWallet && (
                      <>
                        <p>• Total Wallets: {summaryData.wallets?.totalWallets || 0}</p>
                        <p>• Total Balance: ₹{summaryData.wallets?.totalWalletBalance?.toFixed(2) || "0.00"}</p>
                      </>
                    )}
                    {clearWithdrawalRequests && (
                      <p>• Pending Requests: {summaryData.withdrawalRequests?.pendingRequests || 0} (₹{summaryData.withdrawalRequests?.totalPendingAmount?.toFixed(2) || "0.00"})</p>
                    )}
                    {clearWithdrawalHistory && (
                      <p>• History Records: {summaryData.withdrawalHistory?.totalRecords || 0} (₹{summaryData.withdrawalHistory?.totalWithdrawnAmount?.toFixed(2) || "0.00"})</p>
                    )}
                  </div>
                </div>
              )}

              <p className="text-gray-700 text-xs text-center">
                Are you absolutely sure which is <strong>IRREVERSIBLE</strong>?
              </p>
            </div>

            {/* Footer */}
            <div className="p-3 bg-gray-50 border-t border-gray-200 rounded-b-xl">
              <div className="flex gap-2">
                <button
                  onClick={() => setShowResetConfirmDialog(false)}
                  disabled={clearingData}
                  className="flex-1 bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded-lg font-medium transition-colors flex items-center justify-center gap-1.5 disabled:opacity-50 text-xs"
                >
                  <FaTimesCircle className="w-3 h-3" />
                  Cancel
                </button>
                <button
                  onClick={clearAllPaymentsAndWallets}
                  disabled={clearingData}
                  className="flex-1 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-3 py-1.5 rounded-lg font-medium transition-all flex items-center justify-center gap-1.5 disabled:opacity-50 text-xs"
                >
                  {clearingData ? (
                    <>
                      <FaSpinner className="w-3 h-3 animate-spin" />
                      Clearing...
                    </>
                  ) : (
                    <>
                      <FaTrashAlt className="w-3 h-3" />
                      Clear All
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full max-h-[80vh] overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-indigo-500 to-purple-500 p-3 text-white">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                  <FaSave className="w-4 h-4" />
                </div>
                <div>
                  <h3 className="text-base font-semibold">Confirm Changes</h3>
                  <p className="text-indigo-100 text-xs">Review your changes before saving</p>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-4 max-h-80 overflow-y-auto">
              <div className="space-y-2">
                {Object.entries(changesSummary).map(([key, value]) => (
                  <div key={key} className="bg-gray-50 rounded-lg p-2 border border-gray-200">
                    <h4 className="font-semibold text-gray-800 text-xs mb-1">{key}</h4>
                    {key === 'Ad Types' ? (
                      <div className="space-y-1">
                        {value.map((adType, index) => (
                          <div key={index} className="flex justify-between items-center text-xs">
                            <span className="text-gray-600 font-medium">{adType.name}:</span>
                            <div className="flex items-center gap-1">
                              <span className="text-red-600 line-through">₹{adType.old}</span>
                              <span className="text-gray-400">→</span>
                              <span className="text-green-600 font-semibold">₹{adType.new}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex justify-between items-center text-xs">
                        <span className="text-red-600 line-through">{value.old}</span>
                        <span className="text-gray-400">→</span>
                        <span className="text-green-600 font-semibold">{value.new}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Footer */}
            <div className="p-3 bg-gray-50 border-t border-gray-200">
              <div className="flex gap-2">
                <button
                  onClick={() => setShowConfirmDialog(false)}
                  className="flex-1 bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded-lg font-medium transition-colors flex items-center justify-center gap-1.5 text-xs"
                >
                  <FaTimesCircle className="w-3 h-3" />
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setShowConfirmDialog(false);
                    savePricingSettings();
                  }}
                  className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white px-3 py-1.5 rounded-lg font-medium transition-all flex items-center justify-center gap-1.5 text-xs"
                >
                  <FaCheckCircle className="w-3 h-3" />
                  Yes, Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PriceSet;

